import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Reset the scroll position to the top whenever the route changes, so each page
// starts at the top instead of inheriting the previous page's scroll offset.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
